
let teaserId;
const teaserSliders = document.querySelectorAll('.teaser-slider');

const teaserSliderInit = function() {
    teaserSliders.forEach((teaserEl) => {
        teaserId = teaserEl.getAttribute('data-teaser-id');

        let teaserSwiper = new Swiper(`#teaser-slider-${teaserId}`, {

            loop: true,
            slidesPerView: 1,
            spaceBetween: 16,

            navigation: {
                nextEl: '.swiper-btn-next',
                prevEl: '.swiper-btn-prev',
            },

            speed: 600,
            autoplay: {
                delay: 8000,
                disableOnInteraction: false,
            },

            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
                1280: {
                    slidesPerView: 3,
                    pagination: false,
                    autoplay: false
                }
            },
        });
    });
}

export { teaserSliderInit }
